import { debounce } from "lodash";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useCallback, useRef, useState } from "react";
import { ApiContainer } from "../utils/api";
import { ON_FORM_CHANGE, SET_API_DATA } from "../redux/constants";

const LearningContainer = () => {
  const searchRef = useRef(null);
  const { api } = ApiContainer();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const from = queryParams.get("from");
  const [showSearch, setShowSearch] = useState(false);
  const [activeTab, setActiveTab] = useState("learning");
  const [searchTerm, setSearchTerm] = useState("");
  const userData = useSelector((state) => state?.app?.userData);
  const isLearningAdmin = userData?.is_learning_admin;
  const bookMarkData = userData?.bookmark || [];
  const { form } = useSelector((state) => state);
  const learningResult = useSelector((state) => state.api.learningResult);
  const learningCategoryData = useSelector(
    (state) => state.api.learningCategoryData
  );
  const learningSearchContent = useSelector(
    (state) => state.api.learningSearchContent
  );
  const LearningLoader = useSelector(
    (state) => state.api?.loader?.learningResult
  );
  const learningSearchLoader = useSelector(
    (state) => state.api?.loader?.learningSearch
  );

  const filters = useSelector((state) => state.form.formData?.learningSearch);

  const getReport = async () => {
    const response = await api({
      method: "GET",
      endPoint: "learning/home",
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "learningResult",
    });

    if (response?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          learningResult: response?.data,
        },
      });
    }
  };

  const getSearchReports = async () => {
    const { keyword } = filters;
    const reportsData = await api({
      method: "GET",
      endPoint: `learning/search?${keyword ? `&key_word=${keyword}` : ""}`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "learningSearch",
      needFullResponse: true,
    });
    if (reportsData?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          learningSearchContent: reportsData?.data,
        },
      });
    } else {
      dispatch({
        type: SET_API_DATA,
        payload: {
          learningSearchContent: [],
        },
      });
    }
  };

  const getCategoryReport = async () => {
    const response = await api({
      method: "GET",
      endPoint: "learning/categories",
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "learningResult",
    });

    if (response?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          learningCategoryData: response?.data,
        },
      });
    }
  };

  const bookmark = (e, id, el) => {
    e.stopPropagation();
    const check = bookMarkData && bookMarkData?.some((i) => i.course_id === id);
    if (check) {
      const remove = bookMarkData.filter((i) => i.course_id !== id);
      dispatch({
        type: "SET_USER_DATA",
        payload: {
          ...userData,
          bookmark: remove,
        },
      });
    } else {
      const newData = bookMarkData ? [...bookMarkData, el] : [el];
      dispatch({
        type: "SET_USER_DATA",
        payload: {
          ...userData,
          bookmark: newData,
        },
      });
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleCloseSearch = () => {
    searchRef.current.value = "";
    dispatch({
      type: SET_API_DATA,
      payload: {
        learningSearchContent: [],
      },
    });
  };

  useEffect(() => {
    if (filters?.keyword && activeTab === "search") {
      getSearchReports();
    }
  }, [filters?.keyword, activeTab]);

  useEffect(() => {
    if (searchRef.current) searchRef.current.value = filters?.keyword;
  }, [filters?.keyword]);

  useEffect(() => {
    if (activeTab !== "search") {
      dispatch({
        type: ON_FORM_CHANGE,
        payload: {
          formData: {
            ...form.formData,
            learningSearch: {
              ...filters,
              keyword: "",
            },
          },
        },
      });

      dispatch({
        type: SET_API_DATA,
        payload: {
          learningSearchContent: [],
        },
      });

      if (searchRef.current) {
        searchRef.current.value = "";
      }
    }
  }, [activeTab]);

  const onSearch = (e) => {
    const { value } = e.target;
    dispatch({
      type: ON_FORM_CHANGE,
      payload: {
        formData: {
          ...form.formData,
          learningSearch: {
            ...filters,
            // page: 1,
            keyword: value,
          },
        },
      },
    });
  };
  const onSearchChange = useCallback(debounce(onSearch, 500), [filters]);

  useEffect(() => {
    if (!learningResult || learningResult.length === 0) {
      getReport();
    }
  }, [learningResult]);

  useEffect(() => {
    if (from === "learningAdmin") {
      getReport();
    }
  }, [from]);

  useEffect(() => {
    if (from === "categorys") {
      setActiveTab("checklist");
    }
  }, [from]);

  useEffect(() => {
    if (
      (activeTab === "checklist" && !learningCategoryData) ||
      learningCategoryData?.length === 0
    ) {
      getCategoryReport();
    }
  }, [activeTab]);

  return {
    learningResult,
    LearningLoader,
    onSearchChange,
    searchRef,
    learningSearchContent,
    learningSearchLoader,
    learningCategoryData,
    activeTab,
    setActiveTab,
    showSearch,
    setSearchTerm,
    bookMarkData,
    bookmark,
    handleSearchChange,
    handleCloseSearch,
    isLearningAdmin,
  };
};

export default LearningContainer;
